import { ReactNode } from 'react';
import cx from 'classnames';

import styles from './Text.module.sass';

type TextWeight = 'regular' | 'medium' | 'semi-bold' | 'bold';
type TextColor = 'black' | 'primary' | 'gray' | 'red' | 'currentColor';
type TextWrap = 'nowrap' | 'ellipsis';

export type TextProps = {
  weight?: TextWeight;
  color?: TextColor;
  wrap?: TextWrap;
};

interface TextInterface extends TextProps {
  children: ReactNode;
  className?: string;
}

const Text = ({ weight, color, wrap, children, className }: TextInterface) => {
  const classes = cx(
    styles.text,
    styles[`text--${color}`],
    {
      [styles[`text--${wrap}`]]: wrap,
      [styles[`text--${weight}`]]: weight,
    },
    className,
  );

  return <div className={classes}>{children}</div>;
};

export default Text;
